import { createFileRoute } from '@tanstack/react-router';

import { AuditFindingsPage } from '@/features/audit-workflow/components/AuditFindingsPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/findings')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditFindings'),
  }),
  component: AuditFindingsRoute,
});

function AuditFindingsRoute() {
  return <AuditFindingsPage />;
}
